import { render } from "./UnlockIcon.svg?vue&type=template&id=755a320c"
const script = {}
script.render = render

export default script